import axios from 'axios';

export default (BASE_URL) => ({
  login: function(credentials) {
    // eslint-disable-next-line

    return new Promise((res, rej) => {
      axios.post(BASE_URL + 'login', credentials).then(function (response) {
        if (response.data !== 'Login failed') {
          localStorage.setItem('jwt_token', response.data.token); // change on jwt token
          localStorage.setItem('login_date', Date.now().toString());
          res({ success: true });
        } else {
          res({ success: false });
        }
      })
      .catch(function (error) {
        console.log(error);
      })
    });
  },
  register: function(credentials) {
    return new Promise((res, rej) => {
      localStorage.setItem('jwt_token', JSON.stringify(credentials)); // change on jwt token
      localStorage.setItem('login_date', Date.now().toString());

      res({ success: true });
    });
  },
  reset: function(email) {
    return new Promise((res, rej) => {
      alert(`reset pass for ${email}`);
    });
  },
  logout: function() {
    return new Promise((res, rej) => {
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('login_date');

      res({ success: true });
    });
  },
  isAuthenticated: function() {
    const loginDate = localStorage.getItem('login_date');
    const jwtToken = localStorage.getItem('jwt_token');

    if (loginDate === null || jwtToken === null) {
      this.logout();

      return false;
    }

    const now = Date.now();
    const delta = 1000 * 60 * 60 * 23; // 23 hours

    if (now - loginDate < delta) {
      return true;
    }

    return false;
  },
});
